/* eslint-disable */
import React, { useState } from "react";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
// import "swiper/scss";
import styles from "./ChannelSlideGroup.module.css";
import "./navigationButton.css";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import { Program } from "../../../stores/program/model/Program";
import SlideNextButton from "../images/SlideNextButton";
import SlidePrevButton from "../images/SlidePrevButton";
import SlideNextButtonFocus from "../images/SlideNextButtonFocus";
import SlidePrevButtonFocus from "../images/SlidePrevButtonFocus";
import PuiTypography from "../../../components/elements/PuiTypography";
SwiperCore.use([Navigation]);
// スライドの型定義
export interface ChannelSlideGroupProps {
  // id
  id: string;
  // 一列に表示させる画像数
  displayNum: number;
  // 画像のループ切り替え
  needLoop: boolean;
  // チャンネルリスト
  ChannelList: Program[];
  // セレクトエリア用コールバック関数
  onCallback: any;
}
export default function ChannelSlideGroup({
  ...props
}: ChannelSlideGroupProps) {
  const [isSlideNextFocus, setIsSlideNextFocus] = useState<boolean>(false);
  const [isSlidePrevFocus, setIsSlidePrevFocus] = useState<boolean>(false);
  const handleClick = (value: any) => {
    props.onCallback(value.target.id);
  };
  return (
    <div>
      <div
        className={`swiper-channel-next-${props.id} swiper-channel-next swiper-button-disabled`}
      >
        <div
          className={styles.swiperButton}
          onMouseEnter={() => setIsSlideNextFocus(true)}
          onMouseLeave={() => setIsSlideNextFocus(false)}
        >
          {!isSlideNextFocus && <SlideNextButton />}
          {isSlideNextFocus && <SlideNextButtonFocus />}
        </div>
      </div>
      <div
        className={`swiper-channel-prev-${props.id} swiper-channel-prev swiper-button-disabled`}
      >
        <div
          className={styles.swiperButton}
          onMouseEnter={() => setIsSlidePrevFocus(true)}
          onMouseLeave={() => setIsSlidePrevFocus(false)}
        >
          {!isSlidePrevFocus && <SlidePrevButton />}
          {isSlidePrevFocus && <SlidePrevButtonFocus />}
        </div>
      </div>
      {/* Swiper */}
      <Swiper
        modules={[Navigation]}
        spaceBetween={15}
        slidesPerView={props.displayNum}
        loop={props.needLoop && props.ChannelList.length >= props.displayNum}
        navigation={{
          nextEl: `.swiper-channel-next-${props.id}`,
          prevEl: `.swiper-channel-prev-${props.id}`,
        }}
      >
        {props.ChannelList.map((row, index) => (
          <SwiperSlide key={`${props.id}-${index}`}>
            <div className={styles.slideDiv}>
              <img
                id={row.id}
                src={`${row.showImageUrl || row.imageUrl}`}
                className={styles.slideImg}
                alt={row.title}
                onClick={handleClick}
              />
            </div>
            <div
              id={row.id}
              data-tip={row.title}
              data-for="record"
              className={styles.slideTitle}
              onClick={handleClick}
            >
              <PuiTypography bold size={14}>
                {row.title}
              </PuiTypography>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {/* Tooltip */}
      <PuiTooltip id={"record"} />
    </div>
  );
}
